import { getAppSettings } from '@/lib/appSettings';
function parseSlaMinutes() {
    // User setting takes priority over the build-time default.
    const fromSettings = getAppSettings().slaMinutes;
    if (Number.isFinite(fromSettings) && fromSettings > 0)
        return fromSettings;
    const raw = import.meta.env.VITE_VALIDATION_SLA_MINUTES;
    const n = raw ? Number.parseInt(raw, 10) : 60;
    return Number.isFinite(n) && n > 0 ? n : 60;
}
const SLA_MS = () => parseSlaMinutes() * 60 * 1000;
/** Pending items older than SLA window should be highlighted for supervisors */
export function isSlaBreached(comm, now = Date.now()) {
    if (comm.validationStatus !== 'pending')
        return false;
    const received = Date.parse(comm.receivedDateTime);
    if (Number.isNaN(received))
        return false;
    return now - received > SLA_MS();
}
const LEVEL2_MS = 72 * 60 * 60 * 1000;
/**
 * Human-readable escalation tier when SLA is breached (demo / ops copy).
 */
export function getEscalationDisplay(comm, now = Date.now()) {
    if (comm.validationStatus !== 'pending' || !isSlaBreached(comm, now)) {
        return null;
    }
    const received = Date.parse(comm.receivedDateTime);
    if (Number.isNaN(received))
        return null;
    const ageMs = now - received;
    if (ageMs >= LEVEL2_MS)
        return 'Level 2 Escalation: Overdue';
    return 'Level 1 Escalation: SLA breached';
}
export function isCriticalAlert(comm, now = Date.now()) {
    if (comm.validationStatus !== 'pending')
        return false;
    if (comm.isFraudSuspected === true)
        return true;
    if (comm.urgencyStatus === 'critical')
        return true;
    if (comm.fraudScore >= 70)
        return true;
    return isSlaBreached(comm, now);
}
export function countCriticalAlerts(comms) {
    const now = Date.now();
    return comms.filter((c) => isCriticalAlert(c, now)).length;
}
